// GENERATED FILE - DO NOT EDIT.
// Source: shared/sensors/sensor-registry.json
// Regenerate: node shared/sensors/generate.mjs
/* eslint-disable */

export const SENSOR_CHANNELS = [
  {
    key: "TEMPERATURE_DATA",
    groupKey: "temperature",
    shortName: "Temperature (C)",
    longName: "Temperature",
    unit: "°C",
    group: "environment",
    source: "ble",
    aliases: ["temperature", "temp"],
  },
  {
    key: "TEMPERATURE_DATA_F",
    groupKey: "temperature_f",
    shortName: "Temperature (F)",
    longName: "Temperature (Fahrenheit)",
    unit: "°F",
    group: "environment",
    source: "derived",
    aliases: ["temp_f"],
  },
  {
    key: "HUMIDITY_DATA",
    groupKey: "humidity",
    shortName: "Humidity (%)",
    longName: "Relative Humidity",
    unit: "%",
    group: "environment",
    source: "ble",
    aliases: ["humidity", "hum"],
  },
  {
    key: "PRESSURE_DATA",
    groupKey: "pressure",
    shortName: "Pressure (Pa)",
    longName: "Barometric Pressure",
    unit: "Pa",
    group: "environment",
    source: "telemetry",
    aliases: ["pressure"],
  },
  {
    key: "CO2_DATA",
    groupKey: "co2",
    shortName: "CO2",
    longName: "Carbon Dioxide",
    unit: "ppm",
    group: "gas",
    source: "ble",
    aliases: ["co2", "co2(ppm)"],
  },
  {
    key: "VOC_DATA",
    groupKey: "voc",
    shortName: "VOC",
    longName: "Volatile Organic Compounds",
    unit: "ppm",
    group: "gas",
    source: "ble",
    aliases: ["voc", "tvoc", "tvoc_data", "tvoc(ppm)"],
  },
  {
    key: "HCHO_DATA",
    groupKey: "hcho",
    shortName: "Formaldehyde",
    longName: "Formaldehyde",
    unit: "mg/m³",
    group: "gas",
    source: "ble",
    aliases: ["hcho", "hcho(mg/m3)"],
  },
  {
    key: "CO_DATA",
    groupKey: "co",
    shortName: "Carbon Monoxide",
    longName: "Carbon Monoxide",
    unit: "ppm",
    group: "gas",
    source: "ble",
    aliases: ["co"],
  },
  {
    key: "MERCAPTAN_DATA",
    groupKey: "mercaptan",
    shortName: "Mercaptan",
    longName: "Mercaptan",
    unit: "ppm",
    group: "gas",
    source: "ble",
    aliases: ["mercaptan"],
  },
  {
    key: "NOX_DATA",
    groupKey: "nox",
    shortName: "NOx Index",
    longName: "Nitrogen Oxides Index",
    unit: "index",
    group: "gas",
    source: "ble",
    aliases: ["nox"],
  },
  {
    key: "SP_PM1",
    groupKey: "pm1_0",
    shortName: "PM1.0 Particulates",
    longName: "PM1.0 Mass Concentration",
    unit: "µg/m³",
    group: "particulates",
    source: "ble",
    aliases: ["sp pm1.0", "sp_pm1_data"],
  },
  {
    key: "SP_PM25",
    groupKey: "pm2_5",
    shortName: "PM2.5 Particulates",
    longName: "PM2.5 Mass Concentration",
    unit: "µg/m³",
    group: "particulates",
    source: "ble",
    aliases: ["sp pm2.5", "sp_pm25_data"],
  },
  {
    key: "SP_PM10",
    groupKey: "pm10_0",
    shortName: "PM10.0 Particulates",
    longName: "PM10 Mass Concentration",
    unit: "µg/m³",
    group: "particulates",
    source: "ble",
    aliases: ["sp pm10.0", "sp_pm10_data"],
  },
  {
    key: "AE_PM1.0",
    groupKey: "pm1_0",
    shortName: "PM1.0 Particulates",
    longName: "PM1.0 Mass Concentration (Atmospheric)",
    unit: "µg/m³",
    group: "atmospheric",
    source: "ble",
    aliases: ["ae pm1.0", "pm1.0(ae ppm)", "pm1.0_ultra_fine_particulates_data", "pm1", "pm1_data"],
  },
  {
    key: "AE_PM2.5",
    groupKey: "pm2_5",
    shortName: "PM2.5 Particulates",
    longName: "PM2.5 Mass Concentration (Atmospheric)",
    unit: "µg/m³",
    group: "atmospheric",
    source: "ble",
    aliases: ["ae pm2.5", "pm2.5(ae ppm)", "pm2.5_fine_particles_data", "pm2.5"],
  },
  {
    key: "AE_PM10.0",
    groupKey: "pm10_0",
    shortName: "PM10.0 Particulates",
    longName: "PM10 Mass Concentration (Atmospheric)",
    unit: "µg/m³",
    group: "atmospheric",
    source: "ble",
    aliases: ["ae pm10.0", "ae pm10", "pm10.0(ae ppm)", "pm10.0_data"],
  },
  {
    key: "0.3_PER_100_CM^3_DATA",
    groupKey: "count_0_3",
    shortName: "0.3um Particles",
    longName: "0.3um Particle Count",
    unit: "#/100cm³",
    group: "particle_count",
    source: "ble",
    aliases: ["num_particles_0.3", "sp pm0.3", "0.3um particles"],
  },
  {
    key: "0.5_PER_100_CM^3_DATA",
    groupKey: "count_0_5",
    shortName: "0.5um Particles",
    longName: "0.5um Particle Count",
    unit: "#/100cm³",
    group: "particle_count",
    source: "ble",
    aliases: ["num_particles_0.5", "sp pm0.5", "0.5um particles"],
  },
  {
    key: "1.0_PER_100_CM^3_DATA",
    groupKey: "count_1_0",
    shortName: "1um Particles",
    longName: "1.0um Particle Count",
    unit: "#/100cm³",
    group: "particle_count",
    source: "ble",
    aliases: ["num_particles_1.0", "1.0um particles"],
  },
  {
    key: "2.5_PER_100_CM^3_DATA",
    groupKey: "count_2_5",
    shortName: "2.5um Particles",
    longName: "2.5um Particle Count",
    unit: "#/100cm³",
    group: "particle_count",
    source: "ble",
    aliases: ["num_particles_2.5", "2.5um particles"],
  },
  {
    key: "5.0_PER_100_CM^3_DATA",
    groupKey: "count_5_0",
    shortName: "5um Particles",
    longName: "5.0um Particle Count",
    unit: "#/100cm³",
    group: "particle_count",
    source: "ble",
    aliases: ["num_particles_5.0", "5.0um particles"],
  },
  {
    key: "10.0_PER_100_CM^3_DATA",
    groupKey: "count_10_0",
    shortName: "10um Particles",
    longName: "10.0um Particle Count",
    unit: "#/100cm³",
    group: "particle_count",
    source: "ble",
    aliases: ["num_particles_10.0", "10.0um particles"],
  },
  {
    key: "GPS",
    groupKey: "gps",
    shortName: "GPS",
    longName: "Device GPS",
    unit: null,
    group: "location",
    source: "builtin",
    aliases: ["builtingps"],
  },
  {
    key: "DEVICE_BATTERY",
    groupKey: "device_battery",
    shortName: "Device Battery",
    longName: "Device Battery",
    unit: "%",
    group: "device",
    source: "builtin",
    aliases: ["device battery"],
  },
  {
    key: "DEVICE_SENSOR_ID",
    groupKey: "device_sensor_id",
    shortName: "Device Sensor ID",
    longName: "Device Sensor ID",
    unit: null,
    group: "device",
    source: "builtin",
    aliases: ["device sensor id"],
  },
  {
    key: "PARTICLE_COUNT",
    groupKey: "particle_count_total",
    shortName: "Particle Count",
    longName: "Total Particle Count",
    unit: "#/100cm³",
    group: "particle_count",
    source: "derived",
    aliases: ["particle count"],
  },
  {
    key: "RANDOM",
    groupKey: "random",
    shortName: "RNG",
    longName: "Random Number Generator",
    unit: null,
    group: "dev",
    source: "builtin",
    aliases: [],
  },
];

/** Every lookup token (canonical key + aliases), lowercased, to its channel. */
export const SENSOR_CHANNEL_BY_TOKEN = SENSOR_CHANNELS.reduce((acc, channel) => {
  acc[channel.key.toLowerCase()] = channel;
  channel.aliases.forEach((alias) => {
    acc[alias.toLowerCase()] = channel;
  });
  return acc;
}, {});

export const lookupSensorChannel = (token) =>
  (typeof token === 'string' ? SENSOR_CHANNEL_BY_TOKEN[token.toLowerCase()] : undefined) || undefined;
